import * as React from "react";
import { observer } from "mobx-react-lite";
import { TranslationContext, useTranslation } from "src/hooks";
import { FilePickerContainer } from "./components/Container.component";
import { FilePickerContext, FilePickerState } from "./states";

export type IFilePickerWithPreviewProps = {
  helperText?: string;
  isLoading?: boolean;
  isError?: boolean;
  onChange?: (files: File) => void;
  previewUrl?: string;
  maxSize?: number; // in megabyte, default is 10MB
  onInfoClick?: () => void;
  onDelete?: () => void;
  tempFile?: File;
  onClick?: () => void;
  onError?: (errors: Error) => void;
  metadata?: any;
  mediaType?: string;
};

export const FilePickerWithPreview: React.FC<IFilePickerWithPreviewProps> = observer(
  (props) => {
    const {
      onChange,
      onInfoClick,
      onDelete,
      tempFile,
      onClick,
      onError,
      ...other
    } = props;
    const translate = useTranslation(require("../translations.json"));
    const [temporaryFile, setTemporaryFile] = React.useState<File | undefined>(
      tempFile!
    );
    const inputRef = React.useRef<HTMLInputElement>(null);

    const _onChange = (file: File) => {
      setTemporaryFile(file);
      onChange?.(file);
    };

    const _onDelete = () => {
      setTemporaryFile(undefined);
      // @ts-ignore
      inputRef.current.value = "";
      onDelete?.();
    };

    const state = new FilePickerState(
      { temporaryFile: temporaryFile, ...other },
      _onChange,
      onInfoClick,
      translate,
      inputRef,
      _onDelete,
      onClick,
      onError
    );

    return (
      <TranslationContext.Provider value={require("../translations.json")}>
        <FilePickerContext.Provider value={state}>
          <FilePickerContainer />
        </FilePickerContext.Provider>
      </TranslationContext.Provider>
    );
  }
);
